import { restClient } from '@/Core'

export const ChangeExecutorStatusTask = async (executorUuid: string, status: string): Promise<void> => {
    await restClient.post(`/services/vehicle-need-executors/${executorUuid}/change-status`, { json: { status } })
}
